import { clone, featureCollection } from '@turf/turf';
import { Feature, FeatureCollection, GeoJsonProperties, Geometry } from 'geojson';
import { MapLayerMouseEvent, MapboxGeoJSONFeature } from 'mapbox-gl';

export type MapFeature<P = GeoJsonProperties, Source extends string = string> = {
    feature: FeatureWithSource<P, Source>;
    x: number;
    y: number;
};

export type FeatureWithSource<
    P = GeoJsonProperties,
    Source extends string = string,
    G extends Geometry = Geometry,
> = Feature<G, P> & { source: Source; sourceLayer?: string };

export const cloneFeature = (f: FeatureWithSource | MapboxGeoJSONFeature): FeatureWithSource => {
    const { type, geometry, properties, source, id, bbox, sourceLayer } = f;
    return clone({ type, geometry, properties, source, id, bbox, sourceLayer } as any);
};

export const getFeaturesFromEvent = (event: MapLayerMouseEvent) => {
    const {
        features,
        point: { x, y },
    } = event;

    if (features) return { features: features.map(cloneFeature), x, y };
};

export const emptyFeatures: FeatureCollection = featureCollection([]);
